const tabsEnumValues = [
  'agent',
  'widgetFormSettings',
  'webLinkGenerator',
  'telephony',
] as const;
export type TabsEnum = (typeof tabsEnumValues)[number];

const isTabsEnum = (value: any): value is TabsEnum => {
  return tabsEnumValues.includes(value);
};
const processName = (name?: string | null): TabsEnum => {
  if (!name) return 'agent';
  return isTabsEnum(name) ? name : 'agent';
};

export const getDefaultTab = () => {
  return processName(
    new URLSearchParams(window.location.search).get('tab_name')
  );
};
